export default __webpack_public_path__ + "static/media/Germany.6bcd8aaa.svg";